// @flow
import React, { Component } from 'react';
import { InputSelect } from 'Components/frameworks/form-inputs/input-select/InputSelect.jsx';
import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { ICONS } from 'Components/utils/icon/icons';

import ReactAppContext from 'Context/ReactAppContext';

export type Props = {
  changeDepartureCity: string => void,
  departureCity: string,
  isDisabled?: boolean,
  isLoading?: boolean,
  informationLabel: string,
  label: string,
  optionsDepartureCities: DepartureCities,
};

export class FilterTransport extends Component<Props> {
  static contextType = ReactAppContext;

  handleDepartureCityChange = (name: string, departureCity: string) => {
    const { changeDepartureCity } = this.props;

    changeDepartureCity(departureCity);
  };

  render() {
    const {
      departureCity,
      informationLabel,
      isDisabled,
      isLoading,
      label,
      optionsDepartureCities,
    } = this.props;

    const value = departureCity ? departureCity : '';
    const inputTransportId = 'TransportSelectFilter';
    return (
      <div className="px-4 py-6" data-testid="FilterTransport">
        <label className="text-lg font-bold lg:text-center mb-6 block" htmlFor={inputTransportId}>
          {label}
        </label>
        <InputSelect
          className="mb-3"
          dataTestId="search-form-select-transport"
          inputId={inputTransportId}
          isDisabled={isDisabled}
          isLoading={isLoading || optionsDepartureCities.length === 0}
          mediumText
          onChange={this.handleDepartureCityChange}
          options={optionsDepartureCities}
          value={value}
        />
        <div className="text-sm text-blue font-bold flex">
          <Icon className="rtl:mr-2 flex-shrink-0" width="1.75rem" name={ICONS.ALL_INCLUSIVE} />
          {informationLabel}
        </div>
      </div>
    );
  }
}
